import { Link } from 'react-router-dom';
import ProductForm from '@/pages/products/components/ProductForm';

export default function NewProductPage() {
  return (
    <div>
      <Link
        to="/products"
        className="inline-flex items-center gap-1.5 text-sm font-medium text-foreground-600 hover:text-foreground-900 transition cursor-pointer"
      >
        <i className="ri-arrow-left-line" /> Volver a productos
      </Link>
      <h1 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        Nuevo producto
      </h1>
      <p className="mt-1 text-foreground-600">Completa la información del producto.</p>
      <div className="mt-6">
        <ProductForm />
      </div>
    </div>
  );
}